import PDFDocument from "pdfkit"
import fs from 'fs';

function registerAFMFonts(ctx: any) {
  ctx.keys().forEach((key: string) => {
    const match = key.match(/([^/]*\.afm$)/);
    if (match) {
      // afm files must be stored on data path
      fs.writeFileSync(`data/${match[0]}`, ctx(key));
    }
  });
}

registerAFMFonts((require as any).context('pdfkit/js/data', false, /Helvetica.*\.afm$/));

export var test1 = {
  testdoc: () => generaDoc()
}

function generaDoc() {

  let doc = new PDFDocument()
  doc.fontSize(25)
  doc.text('And here is some wrapped text...')
  doc.fontSize(12)
  doc.moveDown()
  doc.text('Segunda línea Segunda línea Segunda línea Segunda línea Segunda línea Segunda línea Segunda línea Segunda línea Segunda línea Segunda línea Segunda línea Segunda línea Segunda línea Segunda línea Segunda línea Segunda línea Segunda línea Segunda línea')
  // doc.moveDown()
  doc.text('Tercera línea', { continued: true })
  doc.font("Helvetica-Bold")
  doc.text("<b>test1</b>")

  waitForData(doc)
    .then((dataUrl: any) => {
      // display the document in the iframe to the right
      console.log(dataUrl)

      window.open(dataUrl, "_blank")
    })
    .catch(error => {
      console.log(error);
    });

  doc.end();

  console.log(doc)
}

const waitForData = async (doc: any) => {
  return new Promise((resolve, reject) => {
    const buffers: any = [];
    doc.on('data', buffers.push.bind(buffers));
    doc.on('end', async () => {
      const pdfBuffer = Buffer.concat(buffers);
      const pdfBase64 = pdfBuffer.toString('base64');
      resolve(`data:application/pdf;base64,${pdfBase64}`);
    });
    doc.on('error', reject);
  });
};
